import React from 'react';
import { Card, Typography, Divider, Space, Button } from 'antd';
import { ArrowLeftOutlined, FileTextOutlined, CheckCircleOutlined, WarningOutlined, CalendarOutlined } from '@ant-design/icons';
import { useNavigate } from 'react-router-dom';

const { Title, Paragraph, Text } = Typography;

const TermsOfServicePage = () => {
  const navigate = useNavigate();

  return (
    <>
      <style>
        {`
          .terms-of-service-page-container::-webkit-scrollbar {
            width: 12px;
          }
          
          .terms-of-service-page-container::-webkit-scrollbar-track {
            background: #f1f1f1;
            border-radius: 6px;
          }
          
          .terms-of-service-page-container::-webkit-scrollbar-thumb {
            background: #c1c1c1;
            border-radius: 6px;
          }
          
          .terms-of-service-page-container::-webkit-scrollbar-thumb:hover {
            background: #a8a8a8;
          }
        `}
      </style>
      <div 
        className="terms-of-service-page-container"
        style={{ 
          padding: '24px',
          background: 'linear-gradient(135deg, #f5f7fa 0%, #e4e8eb 100%)',
          minHeight: '100vh',
          overflowY: 'auto',
          height: '100vh'
        }}
      >
        <div style={{ 
          maxWidth: '900px', 
          margin: '0 auto',
          paddingBottom: '24px'
        }}>
          <Card 
            style={{ 
              borderRadius: '12px',
              boxShadow: '0 4px 12px rgba(0,0,0,0.1)',
              background: 'linear-gradient(135deg, #ffffff 0%, #f8f9fa 100%)'
            }}
          >
            <div style={{ textAlign: 'center', marginBottom: 32 }}>
              <FileTextOutlined style={{ fontSize: '48px', color: '#1890ff', marginBottom: 16 }} />
              <Title level={1} style={{ margin: 0, color: '#1f2937' }}>
                TERMS OF SERVICE LEADSLOPE
              </Title>
              <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'center', gap: 8, marginTop: 8 }}>
                <CalendarOutlined style={{ color: '#666' }} />
                <Text type="secondary" style={{ fontSize: '16px' }}>
                  Last updated JUNE 16TH, 2025
                </Text>
              </div>
            </div>

            <Divider />

            <Space direction="vertical" size={24} style={{ width: '100%' }}>
              
              {/* Agreement Section */}
              <div>
                <Title level={2} style={{ color: '#1f2937', marginBottom: 16 }}>
                  AGREEMENT TO OUR LEGAL TERMS AND LEAD PURCHASE AGREEMENT
                </Title>
                <Paragraph style={{ fontSize: '16px', lineHeight: 1.6, color: '#374151' }}>
                  We 5<sup>th</sup> Street LLC ("Company," "we," "us," "our"), DBA as LeadSlope, a company registered 
                  in Arizona, United States.
                </Paragraph>
                <Paragraph style={{ fontSize: '16px', lineHeight: 1.6, color: '#374151' }}>
                  We operate the website https://www.Leadslope.com (the "Site"), as well as any other 
                  related products and services that refer or leadslope.com legal terms (the "Legal Terms") 
                  (collectively, the "Services").
                </Paragraph>
                <Paragraph style={{ fontSize: '16px', lineHeight: 1.6, color: '#374151' }}>
                  These Legal Terms constitute a legally binding agreement made between you, whether 
                  personally or on behalf of an entity ("you"), and LeadSlope, concerning your access to and 
                  use of the Services. You agree that by accessing the Services, you have read, understood, 
                  and agreed to be bound by all of these Legal Terms.
                </Paragraph>
                <Paragraph style={{ fontSize: '16px', lineHeight: 1.6, color: '#cf1322', fontWeight: 'bold' }}>
                  IF YOU DO NOT AGREE WITH ALL OF THESE LEGAL TERMS, THEN YOU ARE EXPRESSLY PROHIBITED FROM USING THE 
                  SERVICES AND YOU MUST DISCONTINUE USE IMMEDIATELY.
                </Paragraph>
                <Paragraph style={{ fontSize: '16px', lineHeight: 1.6, color: '#374151' }}>
                  Supplemental terms and conditions or documents that may be posted on the Services 
                  from time to time are hereby expressly incorporated herein by reference. We reserve the 
                  right, in our sole discretion, to make changes or modifications to these Legal Terms from 
                  time to time. It is your responsibility to periodically review these Legal Terms to stay 
                  informed of updates. You will be subject to, and will be deemed to have been made aware 
                  of and to have accepted, the changes in any revised Legal Terms by your continued use of 
                  the Services after the date such revised Legal Terms are posted.
                </Paragraph>
              </div>

              {/* Our Services Section */}
              <div>
                <Title level={3} style={{ color: '#1f2937', marginBottom: 16 }}>
                  1. OUR SERVICES
                </Title>
                <Paragraph style={{ fontSize: '16px', lineHeight: 1.6, color: '#374151' }}>
                  The information provided when using the Services is not intended for distribution to or use 
                  by any person or entity in any jurisdiction or country where such distribution or use would 
                  be contrary to law or regulation or which would subject us to any registration requirement 
                  within such jurisdiction or country. Accordingly, those persons who choose to access the 
                  Services from other locations do so on their own initiative and are solely responsible for 
                  compliance with local laws, if and to the extent local laws are applicable.
                </Paragraph>
                <Paragraph style={{ fontSize: '16px', lineHeight: 1.6, color: '#374151' }}>
                  The Services are not tailored to comply with industry-specific regulations (Health 
                  Insurance Portability and Accountability Act (HIPAA), Federal Information Security 
                  Management Act (FISMA), etc.), so if your interactions would be subjected to such laws, 
                  you may not use the Services. You may not use the Services in a way that would violate the 
                  Gramm-Leach-Bliley Act (GLBA).
                </Paragraph>
              </div>

              {/* Intellectual Property Rights Section */}
              <div>
                <Title level={3} style={{ color: '#1f2937', marginBottom: 16 }}>
                  2. INTELLECTUAL PROPERTY RIGHTS
                </Title>
                
                <Title level={4} style={{ color: '#1f2937', marginBottom: 12 }}>
                  Our intellectual property
                </Title>
                <Paragraph style={{ fontSize: '16px', lineHeight: 1.6, color: '#374151' }}>
                  We are the owner or the licensee of all intellectual property rights in our Services, including 
                  all source code, databases, functionality, software, website designs, audio, video, text, 
                  photographs, and graphics in the Services (collectively, the "Content"), as well as the 
                  trademarks, service marks, and logos contained therein (the "Marks").
                </Paragraph>
                <Paragraph style={{ fontSize: '16px', lineHeight: 1.6, color: '#374151' }}>
                  Our Content and Marks are protected by copyright and trademark laws (and various other 
                  intellectual property rights and unfair competition laws) and treaties in the United States 
                  and around the world.
                </Paragraph>
                <Paragraph style={{ fontSize: '16px', lineHeight: 1.6, color: '#374151' }}>
                  The Content and Marks are provided in or through the Services "AS IS" for your personal, 
                  non-commercial use or internal business purpose only.
                </Paragraph>

                <Title level={4} style={{ color: '#1f2937', marginBottom: 12, marginTop: 24 }}>
                  Your use of our Services
                </Title>
                <Paragraph style={{ fontSize: '16px', lineHeight: 1.6, color: '#374151' }}>
                  Subject to your compliance with these Legal Terms, we grant you a non-exclusive, non-transferable, revocable license to:
                </Paragraph>
                <ul style={{ fontSize: '16px', lineHeight: 1.6, color: '#374151', marginLeft: 24 }}>
                  <li>access the Services in the form of life insurance leads.</li>
                </ul>
                <Paragraph style={{ fontSize: '16px', lineHeight: 1.6, color: '#374151' }}>
                  Except as set out in this section or elsewhere in our Legal Terms, no part of the Services 
                  and no Content or Marks may be copied, reproduced, aggregated, republished, uploaded, 
                  posted, publicly displayed, encoded, translated, transmitted, distributed, sold, licensed, or 
                  otherwise exploited for any commercial purpose whatsoever, without our express prior 
                  written permission.
                </Paragraph>
                <Paragraph style={{ fontSize: '16px', lineHeight: 1.6, color: '#374151' }}>
                  We reserve all rights not expressly granted to you in and to the Services, Content, and 
                  Marks.
                </Paragraph>
                <Paragraph style={{ fontSize: '16px', lineHeight: 1.6, color: '#374151' }}>
                  Any breach of these Intellectual Property Rights will constitute a material breach of our 
                  Legal Terms and your right to use our Services will terminate immediately.
                </Paragraph>

                <Title level={4} style={{ color: '#1f2937', marginBottom: 12, marginTop: 24 }}>
                  Your submissions and contributions
                </Title>
                <Paragraph style={{ fontSize: '16px', lineHeight: 1.6, color: '#374151' }}>
                  When you post or send us any communications, you grant us a license (including use 
                  of your name, trademarks, and logos): By posting any Contributions, you grant us an 
                  unrestricted, unlimited, irrevocable, perpetual, non-exclusive, transferable, royalty-free, 
                  fully-paid, worldwide right, and license to: use, copy, reproduce, distribute, sell, resell, 
                  publish, broadcast, retitle, store, publicly perform, publicly display, reformat, translate, 
                  excerpt (in whole or in part), and exploit your Contributions (including, without limitation, 
                  your image, name, and voice) for any purpose, commercial, advertising, or otherwise, to 
                  prepare derivative works of, or incorporate into other works, your Contributions, and 
                  to sublicense the licenses granted in this section. Our use and distribution may occur in 
                  any media formats and through any media channels.
                </Paragraph>
                <Paragraph style={{ fontSize: '16px', lineHeight: 1.6, color: '#374151' }}>
                  This license includes our use of your name, company name, and franchise name, as 
                  applicable, and any of the trademarks, service marks, trade names, logos, and personal 
                  and commercial images you provide.
                </Paragraph>

                <Title level={4} style={{ color: '#1f2937', marginBottom: 12, marginTop: 24 }}>
                  Copyright infringement
                </Title>
                <Paragraph style={{ fontSize: '16px', lineHeight: 1.6, color: '#374151' }}>
                  We respect the intellectual property rights of others.
                </Paragraph>
              </div>

              {/* User Representations Section */}
              <div>
                <Title level={3} style={{ color: '#1f2937', marginBottom: 16 }}>
                  3. USER REPRESENTATIONS
                </Title>
                <Paragraph style={{ fontSize: '16px', lineHeight: 1.6, color: '#374151' }}>
                  By using the Services, you represent and warrant that:
                </Paragraph>
                <ol style={{ fontSize: '16px', lineHeight: 1.6, color: '#374151', marginLeft: 24 }}>
                  <li>all registration information you submit will be true, accurate, current, and complete;</li>
                  <li>you will maintain the accuracy of such information and promptly update such registration information as necessary;</li>
                  <li>you have the legal capacity and you agree to comply with these Legal Terms;</li>
                  <li>you are not a minor in the jurisdiction in which you reside;</li>
                  <li>you will not access the Services through automated or non-human means, whether through a bot, script or otherwise;</li>
                  <li>you will not use the Services for any illegal or unauthorized purpose; and</li>
                  <li>your use of the Services will not violate any applicable law or regulation.</li>
                </ol>
                <Paragraph style={{ fontSize: '16px', lineHeight: 1.6, color: '#374151' }}>
                  If you provide any information that is untrue, inaccurate, not current, or incomplete, we 
                  have the right to suspend or terminate your account and refuse any and all current or future 
                  use of the Services (or any portion thereof).
                </Paragraph>
              </div>

              {/* User Registration Section */}
              <div>
                <Title level={3} style={{ color: '#1f2937', marginBottom: 16 }}>
                  4. USER REGISTRATION
                </Title>
                <Paragraph style={{ fontSize: '16px', lineHeight: 1.6, color: '#374151' }}>
                  You may be required to register to use the Services. You agree to keep your password 
                  confidential and will be responsible for all use of your account and password. We reserve 
                  the right to remove, reclaim, or change a username you select if we determine, in our sole 
                  discretion, that such username is inappropriate, obscene, or otherwise objectionable.
                </Paragraph>
              </div>

              {/* Purchases and Payment Section */}
              <div>
                <Title level={3} style={{ color: '#1f2937', marginBottom: 16 }}>
                  5. PURCHASES AND PAYMENT
                </Title>
                <Paragraph style={{ fontSize: '16px', lineHeight: 1.6, color: '#374151' }}>
                  We accept the following forms of payment:
                </Paragraph>
                <ul style={{ fontSize: '16px', lineHeight: 1.6, color: '#374151', marginLeft: 24 }}>
                  <li>Visa</li>
                  <li>Mastercard</li>
                  <li>American Express</li>
                  <li>Discover</li>
                </ul>
                <Paragraph style={{ fontSize: '16px', lineHeight: 1.6, color: '#374151' }}>
                  You agree to provide current, complete, and accurate purchase and account information 
                  for all purchases made via the Services. You further agree to promptly update account and 
                  payment information, including email address, payment method, and payment card 
                  expiration date, so that we can complete your transactions and contact you as needed. 
                  Sales tax will be added to the price of purchases as deemed required by us. We may 
                  change prices at any time. All payments shall be in US dollars.
                </Paragraph>
                <Paragraph style={{ fontSize: '16px', lineHeight: 1.6, color: '#374151' }}>
                  You agree to pay all charges at the prices then in effect for your purchases and any 
                  applicable shipping fees, and you authorize us to charge your chosen payment provider for 
                  any such amounts upon placing your order. We reserve the right to correct any errors or 
                  mistakes in pricing, even if we have already requested or received payment.
                </Paragraph>
                <Paragraph style={{ fontSize: '16px', lineHeight: 1.6, color: '#374151' }}>
                  We reserve the right to refuse any lead order placed through the Services. We may, in our 
                  sole discretion, limit or cancel quantities purchased per person, per household, or per 
                  order. These restrictions may include orders placed by or under the same customer 
                  account, the same payment method, and/or orders that use the same billing or shipping 
                  address. We reserve the right to limit or prohibit orders that, in our sole judgment, appear 
                  to be placed by dealers, resellers, or distributors.
                </Paragraph>
              </div>

              {/* Billing Section */}
              <div>
                <Title level={3} style={{ color: '#1f2937', marginBottom: 16 }}>
                  6. BILLING
                </Title>
                <Paragraph style={{ fontSize: '16px', lineHeight: 1.6, color: '#374151' }}>
                  You consent to our charging your payment method on a recurring basis without requiring 
                  your prior approval for each lead purchase charge, until such time as you cancel your 
                  account.
                </Paragraph>

                <Title level={4} style={{ color: '#1f2937', marginBottom: 12, marginTop: 24 }}>
                  Cancellation
                </Title>
                <Paragraph style={{ fontSize: '16px', lineHeight: 1.6, color: '#374151' }}>
                  All lead purchases are non-refundable and user agrees to not charge back any purchase for 
                  any reason. Any chargeback will include a $500 service charge per each lead purchased. 
                  All charges will be processed by stripe through their payment gateway.
                </Paragraph>
                <Paragraph style={{ fontSize: '16px', lineHeight: 1.6, color: '#374151' }}>
                  Requests for lead return(s) via SMS, email, or phone will not be honored. All lead 
                  returns must be initiated by the customer through the platform at www.leadslope.com.
                </Paragraph>

                <Title level={4} style={{ color: '#1f2937', marginBottom: 12, marginTop: 24 }}>
                  Account Data Handling Post-Cancellation
                </Title>
                <Paragraph style={{ fontSize: '16px', lineHeight: 1.6, color: '#374151' }}>
                  Upon cancellation of a user account, all services and data associated with the account will 
                  be permanently deleted within 24 hours of cancellation. Data recovery is not possible after 
                  this time frame, and clients are solely responsible for exporting any necessary data before 
                  account cancellation. All integrations—including but not limited to phone numbers, email 
                  domains, domains, calendar links, automations, payment systems (e.g., Stripe, PayPal), 
                  and third-party services (e.g., Google, Facebook, Slack, QuickBooks)—along with all 
                  LeadSlope features will be deactivated without the possibility of reinstatement.
                </Paragraph>
                <Paragraph style={{ fontSize: '16px', lineHeight: 1.6, color: '#374151' }}>
                  Clients may choose to resubscribe in the future; however, this will result in the creation of a 
                  new account, which will not be associated with any previous account data or settings. 
                  LeadSlope makes no guarantees regarding the availability of previous data or 
                  configurations.
                </Paragraph>
                <Paragraph style={{ fontSize: '16px', lineHeight: 1.6, color: '#374151' }}>
                  LeadSlope shall not be held liable for any losses or inconveniences arising from the 
                  inability to restore prior account information or from data loss, integration disruption, or 
                  inconvenience resulting from account cancellation. LeadSlope reserves the right to modify, 
                  suspend, or discontinue any service or integration at its sole discretion without liability, 
                  even after account reactivation or resubscription. Your cancellation will take effect at the 
                  end of the current paid term.
                </Paragraph>

                <Title level={4} style={{ color: '#1f2937', marginBottom: 12, marginTop: 24 }}>
                  Fee Changes
                </Title>
                <Paragraph style={{ fontSize: '16px', lineHeight: 1.6, color: '#374151' }}>
                  We may, from time to time, make changes to the subscription fee and will communicate 
                  any price changes to you in accordance with applicable law.
                </Paragraph>
              </div>

              {/* Software Section */}
              <div>
                <Title level={3} style={{ color: '#1f2937', marginBottom: 16 }}>
                  7. SOFTWARE
                </Title>
                <Paragraph style={{ fontSize: '16px', lineHeight: 1.6, color: '#374151' }}>
                  We may include software for use in connection with our Services. If such software is 
                  accompanied by an end user license agreement ("EULA"), the terms of the EULA will govern 
                  your use of the software. If such software is not accompanied by a EULA, then we grant to 
                  you a non-exclusive, revocable, personal, and non-transferable license to use such 
                  software solely in connection with our services and in accordance with these Legal Terms. 
                  Any software and any related documentation is provided "AS IS" without warranty of any 
                  kind, either express or implied, including, without limitation, the implied warranties of 
                  merchantability, fitness for a particular purpose, or non-infringement. You accept any and 
                  all risk arising out of use or performance of any software. You may not reproduce or 
                  redistribute any software except in accordance with the EULA or these Legal Terms.
                </Paragraph>
              </div>

              {/* Prohibited Activities Section */}
              <div>
                <Title level={3} style={{ color: '#1f2937', marginBottom: 16 }}>
                  8. PROHIBITED ACTIVITIES
                </Title>
                <Paragraph style={{ fontSize: '16px', lineHeight: 1.6, color: '#374151' }}>
                  You may not access or use the Services for any purpose other than that for which we make 
                  the Services available. The Services may not be used in connection with any 
                  commercial endeavors except those that are specifically endorsed or approved by us.
                </Paragraph>
                <Paragraph style={{ fontSize: '16px', lineHeight: 1.6, color: '#374151' }}>
                  As a user of the Services, you agree not to:
                </Paragraph>
                <ul style={{ fontSize: '16px', lineHeight: 1.6, color: '#374151', marginLeft: 24 }}>
                  <li>Systematically retrieve data or other content from the Services to create or compile, 
                  directly or indirectly, a collection, compilation, database, or directory without 
                  written permission from us.</li>
                  <li>Trick, defraud, or mislead us and other users, especially in any attempt to learn 
                  sensitive account information such as user passwords.</li>
                  <li>Circumvent, disable, or otherwise interfere with security-related features of the 
                  Services, including features that prevent or restrict the use or copying of any 
                  Content or enforce limitations on the use of the Services and/or the Content 
                  contained therein.</li>
                  <li>Disparage, tarnish, or otherwise harm, in our opinion, us and/or the Services.</li>
                  <li>Use any information obtained from the Services in order to harass, abuse, or harm 
                  another person.</li>
                  <li>Make improper use of our support services or submit false reports of abuse or 
                  misconduct.</li>
                  <li>Use the Services in a manner inconsistent with any applicable laws or regulations.</li>
                  <li>Engage in unauthorized framing of or linking to the Services.</li>
                  <li>Upload or transmit (or attempt to upload or to transmit) viruses, Trojan horses, or 
                  other material, including excessive use of capital letters and spamming (continuous 
                  posting of repetitive text), that interferes with any party's uninterrupted use and 
                  enjoyment of the Services or modifies, impairs, disrupts, alters, or interferes with 
                  the use, features, functions, operation, or maintenance of the Services.</li>
                  <li>Engage in any automated use of the system, such as using scripts to send 
                  comments or messages, or using any data mining, robots, or similar data gathering 
                  and extraction tools.</li>
                  <li>Delete the copyright or other proprietary rights notice from any Content.</li>
                  <li>Attempt to impersonate another user or person or use the username of another 
                  user.</li>
                  <li>Upload or transmit (or attempt to upload or to transmit) any material that acts as a 
                  passive or active information collection or transmission mechanism, including 
                  without limitation, clear graphics interchange formats ("gifs"), 1×1 pixels, web bugs, 
                  cookies, or other similar devices (sometimes referred to as "spyware" or "passive 
                  collection mechanisms" or "pcms").</li>
                  <li>Interfere with, disrupt, or create an undue burden on the Services or the networks or 
                  services connected to the Services.</li>
                  <li>Harass, annoy, intimidate, or threaten any of our employees or agents engaged in 
                  providing any portion of the Services to you.</li>
                  <li>Attempt to bypass any measures of the Services designed to prevent or restrict 
                  access to the Services, or any portion of the Services.</li>
                  <li>Copy or adapt the Services' software, including but not limited to Flash, PHP, HTML, 
                  JavaScript, or other code.</li>
                  <li>Except as permitted by applicable law, decipher, decompile, disassemble, or 
                  reverse engineer any of the software comprising or in any way making up a part of 
                  the Services.</li>
                  <li>Except as may be the result of standard search engine or Internet browser usage, 
                  use, launch, develop, or distribute any automated system, including without 
                  limitation, any spider, robot, cheat utility, scraper, or offline reader that accesses the 
                  Services, or use or launch any unauthorized script or other software.</li>
                  <li>Use a buying agent or purchasing agent to make purchases on the Services.</li>
                  <li>Make any unauthorized use of the Services, including collecting usernames and/or 
                  email addresses of users by electronic or other means for the purpose of sending 
                  unsolicited email, or creating user accounts by automated means or under 
                  false pretenses.</li>
                  <li>Use the Services as part of any effort to compete with us or otherwise use the 
                  Services and/or the Content for any revenue-generating endeavor or commercial 
                  enterprise.</li>
                  <li>Sell or otherwise transfer your profile.</li>
                </ul>
              </div>

              {/* Advertisers Section */}
              <div>
                <Title level={3} style={{ color: '#1f2937', marginBottom: 16 }}>
                  9. ADVERTISERS
                </Title>
                <Paragraph style={{ fontSize: '16px', lineHeight: 1.6, color: '#374151' }}>
                  We allow advertisers to display their advertisements and other information in certain areas 
                  of the Services, such as sidebar advertisements or banner advertisements. We simply 
                  provide the space to place such advertisements, and we have no other relationship with 
                  advertisers.
                </Paragraph>
              </div>

              {/* Services Management Section */}
              <div>
                <Title level={3} style={{ color: '#1f2937', marginBottom: 16 }}>
                  16. SERVICES MANAGEMENT
                </Title>
                <Paragraph style={{ fontSize: '16px', lineHeight: 1.6, color: '#374151' }}>
                  We reserve the right, but not the obligation, to:
                </Paragraph>
                <ol style={{ fontSize: '16px', lineHeight: 1.6, color: '#374151', marginLeft: 24 }}>
                  <li>monitor the Services for violations of these Legal Terms;</li>
                  <li>take appropriate legal action against anyone who, in our sole discretion, violates the law or these Legal Terms, including without limitation, reporting such user to law enforcement authorities;</li>
                  <li>in our sole discretion and without limitation, refuse, restrict access to, limit the availability of, or disable (to the extent technologically feasible) any of your Contributions or any portion thereof;</li>
                  <li>in our sole discretion and without limitation, notice, or liability, to remove from the Services or otherwise disable all files and content that are excessive in size or are in any way burdensome to our systems; and</li>
                  <li>otherwise manage the Services in a manner designed to protect our rights and property and to facilitate the proper functioning of the Services.</li>
                </ol>
              </div>

              {/* Privacy Policy Section */}
              <div>
                <Title level={3} style={{ color: '#1f2937', marginBottom: 16 }}>
                  17. PRIVACY POLICY
                </Title>
                <Paragraph style={{ fontSize: '16px', lineHeight: 1.6, color: '#374151' }}>
                  We care about data privacy and security. Please review our Privacy 
                  Policy: <a href="https://leadslope.com/privacy" target="_blank" rel="noopener noreferrer" style={{ color: '#1890ff' }}>leadslope.com/privacy</a>. By using the Services, you agree to be bound by our 
                  Privacy Policy, which is incorporated into these Legal Terms. Please be advised the Services 
                  are hosted in the United States. If you access the Services from any other region of the 
                  world with laws or other requirements governing personal data collection, use, or 
                  disclosure that differ from applicable laws in the United States, India, Germany, Ireland, United 
                  Kingdom, Italy, France, Spain, Sweden and Switzerland, then through your continued use of 
                  the Services, you are transferring your data to the United States, India, Germany, Ireland, United 
                  Kingdom, Italy, France, Spain, Sweden and Switzerland, and you expressly consent to have 
                  your data transferred to and processed in the United States.
                </Paragraph>
              </div>

              {/* Copyright Infringements Section */}
              <div>
                <Title level={3} style={{ color: '#1f2937', marginBottom: 16 }}>
                  18. COPYRIGHT INFRINGEMENTS
                </Title>
                <Paragraph style={{ fontSize: '16px', lineHeight: 1.6, color: '#374151' }}>
                  We respect the intellectual property rights of others. If you believe that any material 
                  available on or through the Services infringes upon any copyright you own or control, 
                  please immediately notify us using the contact information provided below 
                  (a "Notification"). A copy of your Notification will be sent to the person who posted or 
                  stored the material addressed in the Notification. Please be advised that pursuant to 
                  applicable law you may be held liable for damages if you make material 
                  misrepresentations in a Notification. Thus, if you are not sure that material located on or 
                  linked to by the Services infringes your copyright, you should consider first contacting an 
                  attorney.
                </Paragraph>
              </div>

              {/* Term and Termination Section */}
              <div>
                <Title level={3} style={{ color: '#1f2937', marginBottom: 16 }}>
                  19. TERM AND TERMINATION
                </Title>
                <Paragraph style={{ fontSize: '16px', lineHeight: 1.6, color: '#374151' }}>
                  These Legal Terms shall remain in full force and effect while you use the Services. 
                  WITHOUT LIMITING ANY OTHER PROVISION OF THESE LEGAL TERMS, WE RESERVE THE 
                  RIGHT TO, IN OUR SOLE DISCRETION AND WITHOUT NOTICE OR LIABILITY, DENY ACCESS 
                  TO AND USE OF THE SERVICES (INCLUDING BLOCKING CERTAIN IP ADDRESSES), TO ANY 
                  PERSON FOR ANY REASON OR FOR NO REASON, INCLUDING WITHOUT LIMITATION FOR 
                  BREACH OF ANY REPRESENTATION, WARRANTY, OR COVENANT CONTAINED IN THESE 
                  LEGAL TERMS OR OF ANY APPLICABLE LAW OR REGULATION. WE MAY TERMINATE YOUR 
                  USE OR PARTICIPATION IN THE SERVICES OR DELETE YOUR ACCOUNT AND ANY 
                  CONTENT OR INFORMATION THAT YOU POSTED AT ANY TIME, WITHOUT WARNING, IN 
                  OUR SOLE DISCRETION.
                </Paragraph>
                <Paragraph style={{ fontSize: '16px', lineHeight: 1.6, color: '#374151' }}>
                  If we terminate or suspend your account for any reason, you are prohibited from registering 
                  and creating a new account under your name, a fake or borrowed name, or the name of any 
                  third party, even if you may be acting on behalf of the third party. In addition to terminating 
                  or suspending your account, we reserve the right to take appropriate legal action, including 
                  without limitation pursuing civil, criminal, and injunctive redress.
                </Paragraph>
              </div>

              {/* Modifications and Interruptions Section */}
              <div>
                <Title level={3} style={{ color: '#1f2937', marginBottom: 16 }}>
                  20. MODIFICATIONS AND INTERRUPTIONS
                </Title>
                <Paragraph style={{ fontSize: '16px', lineHeight: 1.6, color: '#374151' }}>
                  We reserve the right to change, modify, or remove the contents of the Services at any time 
                  or for any reason at our sole discretion without notice. However, we have no obligation to 
                  update any information on our Services. We will not be liable to you or any third party for 
                  any modification, price change, suspension, or discontinuance of the Services.
                </Paragraph>
                <Paragraph style={{ fontSize: '16px', lineHeight: 1.6, color: '#374151' }}>
                  We cannot guarantee the Services will be available at all times. We may experience 
                  hardware, software, or other problems or need to perform maintenance related to the 
                  Services, resulting in interruptions, delays, or errors. We reserve the right to change, revise, 
                  update, suspend, discontinue, or otherwise modify the Services at any time or for any 
                  reason without notice to you. You agree that we have no liability whatsoever for any loss, 
                  damage, or inconvenience caused by your inability to access or use the Services during any 
                  downtime or discontinuance of the Services. Nothing in these Legal Terms will be 
                  construed to obligate us to maintain and support the Services or to supply any corrections, 
                  updates, or releases in connection therewith.
                </Paragraph>
              </div>

              {/* Governing Law Section */}
              <div>
                <Title level={3} style={{ color: '#1f2937', marginBottom: 16 }}>
                  21. GOVERNING LAW
                </Title>
                <Paragraph style={{ fontSize: '16px', lineHeight: 1.6, color: '#374151' }}>
                  These Legal Terms and your use of the Services are governed by and construed in 
                  accordance with the laws of the State of Arizona applicable to agreements made and to be 
                  entirely performed within the State of Arizona, without regard to its conflict of law 
                  principles.
                </Paragraph>
              </div>

              {/* Dispute Resolution Section */}
              <div>
                <Title level={3} style={{ color: '#1f2937', marginBottom: 16 }}>
                  22. DISPUTE RESOLUTION
                </Title>
                
                <Title level={4} style={{ color: '#1f2937', marginBottom: 12 }}>
                  Informal Negotiations
                </Title>
                <Paragraph style={{ fontSize: '16px', lineHeight: 1.6, color: '#374151' }}>
                  To expedite resolution and control the cost of any dispute, controversy, or claim related to 
                  these Legal Terms (each a "Dispute" and collectively, the "Disputes") brought by either you 
                  or us (individually, a "Party" and collectively, the "Parties"), the Parties agree to first attempt 
                  to negotiate any Dispute (except those Disputes expressly provided below) informally for at 
                  least thirty (30) days before initiating arbitration. Such informal negotiations commence 
                  upon written notice from one Party to the other Party.
                </Paragraph>

                <Title level={4} style={{ color: '#1f2937', marginBottom: 12, marginTop: 24 }}>
                  Binding Arbitration
                </Title>
                <Paragraph style={{ fontSize: '16px', lineHeight: 1.6, color: '#374151' }}>
                  If the Parties are unable to resolve a Dispute through informal negotiations, the Dispute 
                  (except those Disputes expressly excluded below) will be finally and exclusively resolved by 
                  binding arbitration. <Text strong style={{ color: '#cf1322' }}>YOU UNDERSTAND THAT WITHOUT THIS PROVISION, YOU WOULD 
                  HAVE THE RIGHT TO SUE IN COURT AND HAVE A JURY TRIAL.</Text> The arbitration shall be 
                  commenced and conducted under the Commercial Arbitration Rules of the American 
                  Arbitration Association ("AAA") and, where appropriate, the AAA's Supplementary 
                  Procedures for Consumer Related Disputes ("AAA Consumer Rules"), both of which are 
                  available at the American Arbitration Association (AAA) website. Your arbitration fees and 
                  your share of arbitrator compensation shall be governed by the AAA Consumer Rules and, 
                  where appropriate, limited by the AAA Consumer Rules. The arbitration may be conducted 
                  in person, through the submission of documents, by phone, or online. The arbitrator will 
                  make a decision in writing, but need not provide a statement of reasons unless requested 
                  by either Party. The arbitrator must follow applicable law, and any award may be challenged 
                  if the arbitrator fails to do so. Except where otherwise required by the applicable AAA rules 
                  or applicable law, the arbitration will take place in Phoenix, Arizona. Except as otherwise 
                  provided herein, the Parties may litigate in court to compel arbitration, stay proceedings 
                  pending arbitration, or to confirm, modify, vacate, or enter judgment on the award entered 
                  by the arbitrator.
                </Paragraph>
                <Paragraph style={{ fontSize: '16px', lineHeight: 1.6, color: '#374151' }}>
                  If for any reason, a Dispute proceeds in court rather than arbitration, the Dispute shall be 
                  commenced or prosecuted in the state and federal courts located in Phoenix, Arizona, and 
                  the Parties hereby consent to, and waive all defenses of lack of personal jurisdiction, and 
                  forum non conveniens with respect to venue and jurisdiction in such state and federal 
                  courts. Application of the United Nations Convention on Contracts for the International 
                  Sale of Goods and the Uniform Computer Information Transaction Act (UCITA) are excluded 
                  from these Legal Terms.
                </Paragraph>
                <Paragraph style={{ fontSize: '16px', lineHeight: 1.6, color: '#374151' }}>
                  In no event shall any Dispute brought by either Party related in any way to the Services be 
                  commenced more than one (1) years after the cause of action arose. If this provision is 
                  found to be illegal or unenforceable, then neither Party will elect to arbitrate any Dispute 
                  falling within that portion of this provision found to be illegal or unenforceable and such 
                  Dispute shall be decided by a court of competent jurisdiction within the courts listed for 
                  jurisdiction above, and the Parties agree to submit to the personal jurisdiction of that court.
                </Paragraph>

                <Title level={4} style={{ color: '#1f2937', marginBottom: 12, marginTop: 24 }}>
                  Restrictions
                </Title>
                <Paragraph style={{ fontSize: '16px', lineHeight: 1.6, color: '#374151' }}>
                  The Parties agree that any arbitration shall be limited to the Dispute between the Parties 
                  individually. To the full extent permitted by law, (a) no arbitration shall be joined with any 
                  other proceeding; (b) there is no right or authority for any Dispute to be arbitrated on a 
                  class-action basis or to utilize class action procedures; and (c) there is no right or authority 
                  for any Dispute to be brought in a purported representative capacity on behalf of the 
                  general public or any other persons.
                </Paragraph>

                <Title level={4} style={{ color: '#1f2937', marginBottom: 12, marginTop: 24 }}>
                  Exceptions to Informal Negotiations and Arbitration
                </Title>
                <Paragraph style={{ fontSize: '16px', lineHeight: 1.6, color: '#374151' }}>
                  The Parties agree that the following Disputes are not subject to the above provisions 
                  concerning informal negotiations binding arbitration: (a) any Disputes seeking to enforce or 
                  protect, or concerning the validity of, any of the intellectual property rights of a Party; (b) 
                  any Dispute related to, or arising from, allegations of theft, piracy, invasion of privacy, 
                  or unauthorized use; and (c) any claim for injunctive relief. If this provision is found to be 
                  illegal or unenforceable, then neither Party will elect to arbitrate any Dispute falling within 
                  that portion of this provision found to be illegal or unenforceable and such Dispute shall be 
                  decided by a court of competent jurisdiction within the courts listed for jurisdiction above, 
                  and the Parties agree to submit to the personal jurisdiction of that court.
                </Paragraph>
              </div>

              {/* Corrections Section */}
              <div>
                <Title level={3} style={{ color: '#1f2937', marginBottom: 16 }}>
                  23. CORRECTIONS
                </Title>
                <Paragraph style={{ fontSize: '16px', lineHeight: 1.6, color: '#374151' }}>
                  There may be information on the Services that contains typographical errors, inaccuracies, 
                  or omissions, including descriptions, pricing, availability, and various other information. 
                  We reserve the right to correct any errors, inaccuracies, or omissions and to change or 
                  update the information on the Services at any time, without prior notice.
                </Paragraph>
              </div>

              {/* Disclaimer Section */}
              <div>
                <Title level={3} style={{ color: '#1f2937', marginBottom: 16 }}>
                  24. DISCLAIMER
                </Title>
                <Paragraph style={{ fontSize: '16px', lineHeight: 1.6, color: '#374151' }}>
                  THE SERVICES ARE PROVIDED ON AN AS-IS AND AS-AVAILABLE BASIS. YOU AGREE THAT 
                  YOUR USE OF THE SERVICES WILL BE AT YOUR SOLE RISK. TO THE FULLEST EXTENT 
                  PERMITTED BY LAW, WE DISCLAIM ALL WARRANTIES, EXPRESS OR IMPLIED, IN 
                  CONNECTION WITH THE SERVICES AND YOUR USE THEREOF, INCLUDING, WITHOUT 
                  LIMITATION, THE IMPLIED WARRANTIES OF MERCHANTABILITY, FITNESS FOR A 
                  PARTICULAR PURPOSE, AND NON-INFRINGEMENT. WE MAKE NO WARRANTIES OR 
                  REPRESENTATIONS ABOUT THE ACCURACY OR COMPLETENESS OF THE SERVICES' 
                  CONTENT OR THE CONTENT OF ANY WEBSITES OR MOBILE APPLICATIONS LINKED TO 
                  THE SERVICES AND WE WILL ASSUME NO LIABILITY OR RESPONSIBILITY FOR ANY (1) 
                  ERRORS, MISTAKES, OR INACCURACIES OF CONTENT AND MATERIALS, (2) PERSONAL 
                  INJURY OR PROPERTY DAMAGE, OF ANY NATURE WHATSOEVER, RESULTING FROM YOUR 
                  ACCESS TO AND USE OF THE SERVICES, (3) ANY UNAUTHORIZED ACCESS TO OR USE OF 
                  OUR SECURE SERVERS AND/OR ANY AND ALL PERSONAL INFORMATION AND/OR 
                  FINANCIAL INFORMATION STORED THEREIN, (4) ANY INTERRUPTION OR CESSATION OF 
                  TRANSMISSION TO OR FROM THE SERVICES, (5) ANY BUGS, VIRUSES, TROJAN HORSES, 
                  OR THE LIKE WHICH MAY BE TRANSMITTED TO OR THROUGH THE SERVICES BY ANY 
                  THIRD PARTY, AND/OR (6) ANY ERRORS OR OMISSIONS IN ANY CONTENT AND MATERIALS 
                  OR FOR ANY LOSS OR DAMAGE OF ANY KIND INCURRED AS A RESULT OF THE USE OF 
                  ANY CONTENT POSTED, TRANSMITTED, OR OTHERWISE MADE AVAILABLE VIA THE 
                  SERVICES. WE DO NOT WARRANT, ENDORSE, GUARANTEE, OR ASSUME RESPONSIBILITY 
                  FOR ANY PRODUCT OR SERVICE ADVERTISED OR OFFERED BY A THIRD PARTY THROUGH 
                  THE SERVICES, ANY HYPERLINKED WEBSITE, OR ANY WEBSITE OR MOBILE APPLICATION 
                  FEATURED IN ANY BANNER OR OTHER ADVERTISING, AND WE WILL NOT BE A PARTY TO 
                  OR IN ANY WAY BE RESPONSIBLE FOR MONITORING ANY TRANSACTION BETWEEN YOU 
                  AND ANY THIRD-PARTY PROVIDERS OF PRODUCTS OR SERVICES. AS WITH THE 
                  PURCHASE OF A PRODUCT OR SERVICE THROUGH ANY MEDIUM OR IN ANY 
                  ENVIRONMENT, YOU SHOULD USE YOUR BEST JUDGMENT AND EXERCISE CAUTION 
                  WHERE APPROPRIATE.
                </Paragraph>
              </div>

              {/* Limitations of Liability Section */}
              <div>
                <Title level={3} style={{ color: '#1f2937', marginBottom: 16 }}>
                  25. LIMITATIONS OF LIABILITY
                </Title>
                <Paragraph style={{ fontSize: '16px', lineHeight: 1.6, color: '#374151' }}>
                  IN NO EVENT WILL WE OR OUR DIRECTORS, EMPLOYEES, OR AGENTS BE LIABLE TO YOU 
                  OR ANY THIRD PARTY FOR ANY DIRECT, INDIRECT, CONSEQUENTIAL, EXEMPLARY, 
                  INCIDENTAL, SPECIAL, OR PUNITIVE DAMAGES, INCLUDING LOST PROFIT, LOST 
                  REVENUE, LOSS OF DATA, OR OTHER DAMAGES ARISING FROM YOUR USE OF THE 
                  SERVICES, EVEN IF WE HAVE BEEN ADVISED OF THE POSSIBILITY OF SUCH 
                  DAMAGES. NOTWITHSTANDING ANYTHING TO THE CONTRARY CONTAINED HEREIN, OUR 
                  LIABILITY TO YOU FOR ANY CAUSE WHATSOEVER AND REGARDLESS OF THE FORM OF 
                  THE ACTION, WILL AT ALL TIMES BE LIMITED TO THE AMOUNT PAID, IF ANY, BY YOU TO 
                  US DURING THE one (1) MONTH PERIOD PRIOR TO ANY CAUSE OF ACTION 
                  ARISING. CERTAIN US STATE LAWS AND INTERNATIONAL LAWS DO NOT ALLOW 
                  LIMITATIONS ON IMPLIED WARRANTIES OR THE EXCLUSION OR LIMITATION OF CERTAIN 
                  DAMAGES. IF THESE LAWS APPLY TO YOU, SOME OR ALL OF THE ABOVE DISCLAIMERS OR 
                  LIMITATIONS MAY NOT APPLY TO YOU, AND YOU MAY HAVE ADDITIONAL RIGHTS.
                </Paragraph>
              </div>

              {/* Indemnification Section */}
              <div>
                <Title level={3} style={{ color: '#1f2937', marginBottom: 16 }}>
                  26. INDEMNIFICATION
                </Title>
                <Paragraph style={{ fontSize: '16px', lineHeight: 1.6, color: '#374151' }}>
                  You agree to defend, indemnify, and hold us harmless, including our subsidiaries, affiliates, 
                  and all of our respective officers, agents, partners, and employees, from and against any 
                  loss, damage, liability, claim, or demand, including reasonable attorneys' fees and 
                  expenses, made by any third party due to or arising out of: (1) your Contributions; (2) use of 
                  the Services; (3) breach of these Legal Terms; (4) any breach of your representations and 
                  warranties set forth in these Legal Terms; (5) your violation of the rights of a third party, 
                  including but not limited to intellectual property rights; or (6) any overt harmful act toward 
                  any other user of the Services with whom you connected via the Services. Notwithstanding 
                  the foregoing, we reserve the right, at your expense, to assume the exclusive defense and 
                  control of any matter for which you are required to indemnify us, and you agree to 
                  cooperate, at your expense, with our defense of such claims. We will use reasonable 
                  efforts to notify you of any such claim, action, or proceeding which is subject to this 
                  indemnification upon becoming aware of it.
                </Paragraph>
              </div>

              {/* User Data Section */}
              <div>
                <Title level={3} style={{ color: '#1f2937', marginBottom: 16 }}>
                  27. USER DATA
                </Title>
                <Paragraph style={{ fontSize: '16px', lineHeight: 1.6, color: '#374151' }}>
                  We will maintain certain data that you transmit to the Services for the purpose of managing 
                  the performance of the Services, as well as data relating to your use of the Services. 
                  Although we perform regular routine backups of data, you are solely responsible for all data 
                  that you transmit or that relates to any activity you have undertaken using the Services. You 
                  agree that we shall have no liability to you for any loss or corruption of any such data, and 
                  you hereby waive any right of action against us arising from any such loss or corruption of 
                  such data.
                </Paragraph>
              </div>

              {/* Electronic Communications Section */}
              <div>
                <Title level={3} style={{ color: '#1f2937', marginBottom: 16 }}>
                  28. ELECTRONIC COMMUNICATIONS, TRANSACTIONS, AND SIGNATURES
                </Title>
                <Paragraph style={{ fontSize: '16px', lineHeight: 1.6, color: '#374151' }}>
                  Visiting the Services, sending us emails, and completing online forms constitute electronic 
                  communications. You consent to receive electronic communications, and you agree that 
                  all agreements, notices, disclosures, and other communications we provide to you 
                  electronically, via email and on the Services, satisfy any legal requirement that such 
                  communication be in writing. YOU HEREBY AGREE TO THE USE OF ELECTRONIC 
                  SIGNATURES, CONTRACTS, ORDERS, AND OTHER RECORDS, AND TO ELECTRONIC 
                  DELIVERY OF NOTICES, POLICIES, AND RECORDS OF TRANSACTIONS INITIATED OR 
                  COMPLETED BY US OR VIA THE SERVICES. You hereby waive any rights or requirements 
                  under any statutes, regulations, rules, ordinances, or other laws in any jurisdiction which 
                  require an original signature or delivery or retention of non-electronic records, or to 
                  payments or the granting of credits by any means other than electronic means.
                </Paragraph>
              </div>

              {/* SMS Text Messaging Section */}
              <div>
                <Title level={3} style={{ color: '#1f2937', marginBottom: 16 }}>
                  29. SMS TEXT MESSAGING
                </Title>
                
                <Title level={4} style={{ color: '#1f2937', marginBottom: 12 }}>
                  Program Description
                </Title>
                <Paragraph style={{ fontSize: '16px', lineHeight: 1.6, color: '#374151' }}>
                  By opting into any LeadSlope text messaging program, you expressly consent to receive text 
                  messages (SMS) to your mobile number. LeadSlope text messages may include: account 
                  alerts, appointment reminders, marketing communications, order updates, responses to 
                  inquiries and special offers.
                </Paragraph>

                <Title level={4} style={{ color: '#1f2937', marginBottom: 12, marginTop: 24 }}>
                  Opting Out
                </Title>
                <Paragraph style={{ fontSize: '16px', lineHeight: 1.6, color: '#374151' }}>
                  If at any time you wish to stop receiving SMS messages from us, simply reply to the text with 
                  "STOP." You may receive an SMS message confirming your opt out.
                </Paragraph>

                <Title level={4} style={{ color: '#1f2937', marginBottom: 12, marginTop: 24 }}>
                  Message and Data Rates
                </Title>
                <Paragraph style={{ fontSize: '16px', lineHeight: 1.6, color: '#374151' }}>
                  Please be aware that message and data rates may apply to any SMS messages sent or 
                  received. The rates are determined by your carrier and the specifics of your mobile plan.
                </Paragraph>

                <Title level={4} style={{ color: '#1f2937', marginBottom: 12, marginTop: 24 }}>
                  Support
                </Title>
                <Paragraph style={{ fontSize: '16px', lineHeight: 1.6, color: '#374151' }}>
                  If you have any questions or need assistance regarding our SMS communications, please 
                  email us at support@leadslope.com
                </Paragraph>
              </div>

              {/* California Users Section */}
              <div>
                <Title level={3} style={{ color: '#1f2937', marginBottom: 16 }}>
                  30. CALIFORNIA USERS AND RESIDENTS
                </Title>
                <Paragraph style={{ fontSize: '16px', lineHeight: 1.6, color: '#374151' }}>
                  If any complaint with us is not satisfactorily resolved, you can contact the Complaint 
                  Assistance Unit of the Division of Consumer Services of the California Department of 
                  Consumer Affairs in writing at 1625 North Market Blvd., Suite N 112, Sacramento, 
                  California 95834 or by telephone at (800) 952-5210 or (916) 445-1254.
                </Paragraph>
              </div>

              {/* Miscellaneous Section */}
              <div>
                <Title level={3} style={{ color: '#1f2937', marginBottom: 16 }}>
                  31. MISCELLANEOUS
                </Title>
                <Paragraph style={{ fontSize: '16px', lineHeight: 1.6, color: '#374151' }}>
                  These Legal Terms and any policies or operating rules posted by us on the Services or in 
                  respect to the Services constitute the entire agreement and understanding between you 
                  and us. Our failure to exercise or enforce any right or provision of these Legal Terms shall 
                  not operate as a waiver of such right or provision. These Legal Terms operate to the fullest 
                  extent permissible by law. We may assign any or all of our rights and obligations to others at 
                  any time. We shall not be responsible or liable for any loss, damage, delay, or failure to act 
                  caused by any cause beyond our reasonable control. If any provision or part of a provision 
                  of these Legal Terms is determined to be unlawful, void, or unenforceable, that provision or 
                  part of the provision is deemed severable from these Legal Terms and does not affect the 
                  validity and enforceability of any remaining provisions. There is no joint venture, 
                  partnership, employment or agency relationship created between you and us as a result of 
                  these Legal Terms or use of the Services. You agree that these Legal Terms will not be 
                  construed against us by virtue of having drafted them. You hereby waive any and 
                  all defenses you may have based on the electronic form of these Legal Terms and the lack 
                  of signing by the parties hereto to execute these Legal Terms.
                </Paragraph>
              </div>

              {/* Account Transfer and Usage Restrictions Section */}
              <div>
                <Title level={3} style={{ color: '#1f2937', marginBottom: 16 }}>
                  32. ACCOUNT TRANSFER AND USAGE RESTRICTIONS
                </Title>
                
                <Title level={4} style={{ color: '#1f2937', marginBottom: 12 }}>
                  1. Account Ownership and Permitted Users
                </Title>
                <Paragraph style={{ fontSize: '16px', lineHeight: 1.6, color: '#374151' }}>
                  Each LeadSlope account is owned and controlled solely by the original account holder. While 
                  the account itself is non transferable, the account holder may grant access to authorized 
                  users within their organization. However, the account holder remains ultimately responsible 
                  for all activity within the account and for ensuring compliance with these Terms of Service 
                  by all authorized users.
                </Paragraph>

                <Title level={4} style={{ color: '#1f2937', marginBottom: 12, marginTop: 24 }}>
                  2. Prohibition on Account Transfers
                </Title>
                <Paragraph style={{ fontSize: '16px', lineHeight: 1.6, color: '#374151' }}>
                  Account holders are strictly prohibited from transferring, assigning, selling, leasing, or 
                  sharing their LeadSlope account with any external individual, entity, or organization, 
                  including but not limited to other marketing agencies or businesses, regardless of any 
                  affiliation or ownership. This restriction applies under all circumstances, unless explicitly 
                  authorized in writing by LeadSlope.
                </Paragraph>

                <Title level={4} style={{ color: '#1f2937', marginBottom: 12, marginTop: 24 }}>
                  3. Restrictions on Content and Material
                </Title>
                <Paragraph style={{ fontSize: '16px', lineHeight: 1.6, color: '#374151' }}>
                  All content, data, and materials generated, stored, or processed within your LeadSlope 
                  account, including but not limited to reports, graphics, documents, and other intellectual 
                  property, are for use exclusively within your LeadSlope account by you and your authorized 
                  users. You may not transfer, copy, share, or use these materials outside of the LeadSlope 
                  platform, except as expressly permitted in these Terms of Service or with the express 
                  written consent of LeadSlope. This restriction is in place to protect LeadSlope's proprietary 
                  technology, confidential information, and intellectual property rights.
                </Paragraph>

                <Title level={4} style={{ color: '#1f2937', marginBottom: 12, marginTop: 24 }}>
                  4. Exclusion of Contact Data
                </Title>
                <Paragraph style={{ fontSize: '16px', lineHeight: 1.6, color: '#374151' }}>
                  You may export or transfer contact data, such as names, phone numbers, email addresses, 
                  and other related contact information, from your LeadSlope account, provided that such 
                  actions comply with all applicable privacy laws, including but not limited to the GDPR, 
                  CCPA, and CAN-SPAM Act, as well as LeadSlope's Privacy Policy. This exception is intended 
                  to facilitate legitimate business communications and does not permit the transfer of any 
                  other account data or materials.
                </Paragraph>

                <Title level={4} style={{ color: '#1f2937', marginBottom: 12, marginTop: 24 }}>
                  5. Consequences of Unauthorized Transfer
                </Title>
                <Paragraph style={{ fontSize: '16px', lineHeight: 1.6, color: '#374151' }}>
                  Any unauthorized attempt to transfer, share, or allow access to your LeadSlope account or 
                  its associated content to any unauthorized party will result in immediate account 
                  termination. LeadSlope reserves the right to pursue any and all legal remedies available 
                  under applicable law in the event of an unauthorized transfer. By creating an account with 
                  LeadSlope, you acknowledge and agree to abide by these terms and conditions, which are 
                  designed to ensure the integrity, security, and proper use of the services provided by 
                  LeadSlope.
                </Paragraph>
              </div>

              {/* Phone Call and Messaging Policy Section */}
              <div>
                <Title level={3} style={{ color: '#1f2937', marginBottom: 16 }}>
                  33. PHONE CALL AND MESSAGING POLICY
                </Title>
                <Paragraph style={{ fontSize: '16px', lineHeight: 1.6, color: '#374151' }}>
                  All messaging or calls transmitted from lead information purchased, regardless of use case 
                  or phone number type (e.g., long code or toll-free), must comply with Application-to-
                  Person (A2P) messaging standards. All A2P messages are subject to A2P compliance and the 
                  national DNC list. User accepts all responsibility for calling, texting and emailing leads 
                  purchased from LeadSlope and agrees to indemnify Fifth Street LLC and LeadSlope for all 
                  communications facilitated by user.
                </Paragraph>
              </div>


            </Space>
          </Card>
        </div>
      </div>
    </>
  );
};

export default TermsOfServicePage; 